/* template */
<template><div class="recommend" v-if="(mallData.list.length)"><div class="recommend-title">{{$t('common.guessLike')}}</div><div class="recommend-content"><mpx-view v-for="(item, index) in (mallData.list)" :key="item.goods_id" @tap="goodsClick(item, index)"><card-item :goods="(item)"></card-item></mpx-view></div><mpx-view @tap="viewMore" class="tips-viewmore" v-if="(!mallData.isSoldOut && !mallData.isEnd && !hideSeeMore)">{{$t('common.seeMoreDeals')}}</mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m118fbdbd"}'>
@import "../../lib/stylus/variable.styl"
@import '../../lib/stylus/common'
.recommend
  .recommend-content
    background-color: #fff
  .recommend-title
    font-weight: $fw-semi-bold;
    font-size: 30rpx;
    color: #333333;
    height: 80rpx;
    line-height: 80rpx;
    box-sizing: border-box;
    padding: 0 39rpx;
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { ComponentsMixin } from '../../lib/webx/mpx/mixins/page_detail/component'
import { GlobalEnv } from '../../lib/webx'
import { URLQueries } from '../../lib/webx/global_env/url_query'
import { navigateTo, goGoodsDetail } from '../../lib/webx//utils/ui'
import { Track } from '../../lib/webx/mpx/mixins/page_detail/track'
import { mallTrackStd } from '../../lib/webx/common_methods/track'
import { getProdConfFromApollo } from '../../lib/webx/global_env/get_prod_config'
createComponent({
  mixins: [ ComponentsMixin ],
  // properties: {
  //   id: null,
  //   list: Array,
  //   event: Object
  // },
  attached() {
    mallTrackStd('wyc_ckd5_trippackage_guess_sw', '省钱套餐页猜你喜欢曝光')
  },
  computed: {
    // 隐藏查看更多套餐
    hideSeeMore() {
      console.log('--recommend----hideSeeMore')
      return getProdConfFromApollo(this.mallData.product_type, { searchKey: 'goods_detail.hide_see_more_btn' })
    },
  },
  methods: {
    goodsClick(goods, index) {
      mallTrackStd('wyc_ckd5_trippackage_guess_buy_ck', '省钱套餐页猜你喜欢购买按钮点击')
      goGoodsDetail(goods, { source: 'like', position: index + 1 }, this.mallData.event)
    },
    viewMore() {
      Track.viewMore()
      // toIndex({
      //   cityId: GlobalEnv.locationInfo.cityId,
      //   channelId: GlobalEnv.channelId
      // })
      navigateTo('index', {
        city_id: GlobalEnv.cityId,
        productType: URLQueries.getQuery('productType') || '',
        lat: GlobalEnv.locationInfo.lat,
        lng: GlobalEnv.locationInfo.lng,
      })
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "recommend-list118fbdbd",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'card-item':getComponent(require("./card-item.mpx?component=true&componentId=card-item5f98f9b0")),'mpx-view':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
